<template>
    <form-input class="checkbox-wrapper" :error="error">
        <input
            type="checkbox"
            :name="name"
            :id="id"
            :value="value"
            :checked="checked"
            @change="onChange"
            :disabled="isDisabled"
        >
        <app-label :for="id">{{ label }}
            <template v-if="isRequired"><span class="asterisk">*</span></template>
        </app-label>
        <help-block :text="error" />
    </form-input>
</template>

<script>
    export default {
        model: {
            prop: 'initState',
            event: 'input'
        },
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            name: String,
            id: String,
            value: {
                default: 1
            },
            initState: {
                type: Boolean,
                default: false
            },
            showErrorText: {
                type: Boolean,
                default: true
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                checked: this.initState
            };
        },
        methods: {
            onChange() {
                this.checked = !this.checked;
                this.$emit('input', this.checked);
            }
        },
        watch: {
            initState(value) {
                this.checked = value;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "resources/sass/_variables";

    .checkbox-wrapper {
        display: flex;
        align-items: center;

        label {
            font-size: $primary-font-size;
            margin-bottom: 0;
            color: $content-text-color;
        }
        input {
            margin-right: 7px;
        }
    }
</style>
